<template>
  <v-menu
    v-model="isOpen"
    class="breadcrumb-dropdown-container"
    content-class="breadcrumb-dropdown-content"
    close-on-content-click
  >
    <template #activator="{ props }">
      <DpplChip
        v-bind="props"
        class="breadcrumb-dropdown-activator"
        arrow
        :chip-height="36"
        chip-color="white"
        :is-pill="false"
        :is-active="isOpen"
      >
        <template #label>
          {{ currentPage }}
        </template>
      </DpplChip>
    </template>

    <SubmenuDropdownList
      :always-visible="true"
    >
      <NavigationMenuContent
        :columns="columns"
        :compact="true"
        :link-sections="menuPages"
      >
        <template #header="{ name }">
          <SubmenuDropdownListItem
            class="submenu-dropdown-list-item"
            header
          >
            {{ name }}
          </SubmenuDropdownListItem>
        </template>

        <template
          #item="{
            title, isBeta, isSoon, isUpgrade, isNew,
          }"
        >
          <SubmenuDropdownListItem
            v-bind="{
              isBeta, isSoon, isUpgrade, isNew,
            }"
            @click="breadCrumbLinkClick({ label: title })"
          >
            <div class="navigation-text">
              {{ title }}
            </div>
          </SubmenuDropdownListItem>
        </template>
      </NavigationMenuContent>
    </SubmenuDropdownList>
  </v-menu>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTracking } from '@/stores/tracking/tracking';
import DpplChip from '@/components/datapeople/DpplChip.vue';
import NavigationMenuContent from '@/components/shared/NavigationMenuContent.vue';
import SubmenuDropdownList from '@/components/editor/SubmenuDropdownList.vue';
import SubmenuDropdownListItem from '@/components/editor/SubmenuDropdownListItem.vue';

// Router
const route = useRoute();

defineProps({
  menuPages: { type: Array, default: () => [] },
  columns: { type: Number, default: 3 },
});

const { breadCrumbLinkClick } = useTracking();

const isOpen = ref(false);

const currentPageTitleExceptions = {
  'My Datapeople Administrators': 'My Team',
  'Platform Permissions': 'My Team',
  'Demographic Report Permissions': 'My Team',
};

const currentPage = computed(() => {
  const { title } = route.meta;

  return currentPageTitleExceptions[title] || title;
});
</script>

<style scoped lang="less">
.breadcrumb-dropdown-activator {
  border: 1px solid @stroke-default;
  border-radius: 8px;

  :deep(.v-chip__overlay) {
    display: none;
  }
}

.breadcrumb-dropdown-activator:hover {
  background: @bg-brand-default !important;
  color: @white !important;
}

.v-chip.v-chip--size-default {
  font-size: 13px;
}

.router-link-active {
  .navigation-text {
    text-decoration: underline;
  }
}
</style>
